import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Seo from "../components/Seo";
import Typography from "@mui/material/Typography";
import LazyLoad from "react-lazyload";
import teamchallange from "../finalist_photos/finalsdteamchallange-min.webp";
import sciencecenter from "../finalist_photos/sciencecenter-min.webp";
import finalswalking from "../finalist_photos/finalswalking-min.webp";
import finalseatingdinner from "../finalist_photos/finalseatingdinner-min.webp";
import AOS from "aos";
import "../App.css";
import "./About.css";
import Avatar from "@mui/material/Avatar";
import BoardofAdvisors from "./BoardofAdvisors";
import { styled } from "@mui/material/styles";
import { CONFIG } from "../config";

function News() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.slice(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location]);

  useEffect(() => {
    AOS.init({ duration: 1500 });
  }, []);

  return (
    <>
      <Seo
        title="What is the IRO?"
        path="/about"
        description="Learn about the International Research Olympiad — its mission, history, and the global community of young researchers it has built across 89+ countries."
      />
      {/* Hero Section */}
      <div style={{ backgroundColor: "#f8f9fa", padding: "80px 0 60px 0" }}>
        <div className="container">
          <div
            style={{ textAlign: "center", maxWidth: "800px", margin: "0 auto" }}
          >
            <h1
              style={{
                fontSize: "clamp(2.5rem, 5vw, 3.5rem)",
                fontWeight: "700",
                color: "#1a1a2e",
                marginBottom: "24px",
                letterSpacing: "-0.03em",
              }}
            >
              What is the IRO?
            </h1>
            <p
              style={{
                fontSize: "1.15rem",
                color: "#555",
                lineHeight: "1.8",
              }}
            >
              The International Research Olympiad (IRO), is a competition
              representing 45+ countries' top youth researchers. The IRO is an
              olympiad-style competition dedicated solely to scientific
              research, and aims to promote essential skills for science
              research among young minds. The International Research Olympiad
              tests skills related to critical thinking, analytical reasoning,
              science communication, and more.
            </p>
          </div>
        </div>
      </div>

      {/* Photo Gallery */}
      <div
        className="container"
        style={{ marginTop: "-30px", marginBottom: "60px" }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "20px",
          }}
          data-aos="fade-up"
        >
          <LazyLoad height={200} offset={100} once>
            <img
              src={sciencecenter}
              alt="Science Center"
              style={{
                width: "100%",
                height: "220px",
                objectFit: "cover",
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
              }}
            />
          </LazyLoad>
          <LazyLoad height={200} offset={100} once>
            <img
              src={finalswalking}
              alt="Finals Walking"
              style={{
                width: "100%",
                height: "220px",
                objectFit: "cover",
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
              }}
            />
          </LazyLoad>
          <LazyLoad height={200} offset={100} once>
            <img
              src={finalseatingdinner}
              alt="Finals Dinner"
              style={{
                width: "100%",
                height: "220px",
                objectFit: "cover",
                borderRadius: "12px",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
              }}
            />
          </LazyLoad>
        </div>
      </div>

      {/* Our Mission Section */}
      <div className="container" style={{ padding: "60px 0" }}>
        <div style={{ maxWidth: "800px", margin: "0 auto" }}>
          <h2
            style={{
              fontSize: "2rem",
              fontWeight: "600",
              color: "#1a1a2e",
              marginBottom: "24px",
            }}
          >
            Our Mission
          </h2>
          <p
            style={{
              fontSize: "1.05rem",
              color: "#555",
              lineHeight: "1.8",
              marginBottom: "20px",
            }}
          >
            Designed to inspire and challenge students aged 13-18 around the
            globe, the IRO aims to cultivate many essential qualities of the
            research process. Unlike traditional science olympiads that delve
            into specific subjects, the IRO encourages students to build skills
            that will be useful in any research discipline. Through this,
            participants foster a deeper understanding of the scientific process
            and build overall creativity, critical thinking, and analysis
            skills, forming a foundation for later success.
          </p>
          <p style={{ fontSize: "1.05rem", color: "#555", lineHeight: "1.8" }}>
            Every year, numerous ambitious students from grades 6–12 engage in
            research through local universities and summer programs. Recognizing
            a gap in the development of authentic research skills among these
            students, the IRO was conceived to address this vital need. It
            serves as a platform to empower ambitious students, providing them
            with the skills necessary to make meaningful contributions to the
            scientific community.
          </p>
        </div>
      </div>

      {/* Board of Advisors */}
      <section id="board" style={{ padding: "0 12px" }}>
        <BoardofAdvisors />
      </section>

      {/* Past Examinations */}
      <div style={{ padding: "80px 0", backgroundColor: "#fff" }}>
        <div className="container">
          <div style={{ maxWidth: "800px", margin: "0 auto" }}>
            <h2
              style={{
                fontSize: "2rem",
                fontWeight: "600",
                color: "#1a1a2e",
                marginBottom: "24px",
              }}
            >
              The 2024 IRO Examinations (Concluded)
            </h2>
            <p
              style={{
                fontSize: "1.05rem",
                color: "#555",
                lineHeight: "1.8",
                marginBottom: "20px",
              }}
            >
              The 2024 IRO garnered overwhelming interest with over 3,000
              students interested, and 1,000 taking the Opens level exam. Based
              on critique and discussion with the Board of Advisors, the IRO
              tests student skills across written tests, research proposal
              submissions, research project presentations, and more. There are
              three phases of the contest: opens, semis, and finals. At the IRO
              Awards Ceremony in Cambridge, MA, held in the Harvard Square, the
              medalists and special award recipients were declared.
            </p>
            <p
              style={{
                fontSize: "1.05rem",
                color: "#555",
                lineHeight: "1.8",
                marginBottom: "20px",
              }}
            >
              Administered by a team of researchers guided by an experienced
              Board of Advisors, the IRO has ambitious plans for the future,
              including the implementation of country-based examinations,
              organizing camps, and hosting finals at Harvard Square in
              Cambridge, MA. The 2024 edition was a significant milestone,
              heavily publicized to introduce and reward students who are
              developing essential research skills.
            </p>
            <p
              style={{ fontSize: "1.05rem", color: "#555", lineHeight: "1.8" }}
            ></p>{" "}
            We invite you to embark on this exciting journey with us as we shape
            the future of science research. We encourage you to check out the{" "}
            <a
              style={{ color: "#004d99", fontWeight: "600" }}
              href="/winners-hub"
            >
              2026 winners
            </a>{" "}
            of the competition and the highlight reel!
          </div>
        </div>
      </div>

      {/* About Us Section */}
      <div style={{ backgroundColor: "#f8f9fa", padding: "80px 0" }}>
        <div className="container">
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: "60px",
              maxWidth: "1000px",
              margin: "0 auto",
            }}
          >
            <div style={{ flex: "1", minWidth: "300px" }}>
              <h2
                style={{
                  fontSize: "2rem",
                  fontWeight: "600",
                  color: "#1a1a2e",
                  marginBottom: "24px",
                }}
              >
                About Us
              </h2>
              <p
                style={{
                  fontSize: "1.05rem",
                  color: "#555",
                  lineHeight: "1.8",
                }}
              >
                The International Research Olympiad (IRO) is dedicated to honing
                analytical and critical thinking skills for student
                researchers—essential in scientific exploration. The IRO fosters
                a culture of rigorous research and skill-building, not just
                memorizing formulae. The practical applications of knowledge and
                big-picture thinking are tested in the IRO examinations,
                allowing students to walk away with a deeper passion for
                scientific inquiry.
              </p>
            </div>
            <div style={{ flex: "1", minWidth: "300px" }}>
              <LazyLoad height={300} offset={100} once>
                <img
                  src={teamchallange}
                  alt="Team Challenge"
                  style={{
                    width: "100%",
                    maxWidth: "450px",
                    borderRadius: "16px",
                    boxShadow: "0 8px 30px rgba(0, 0, 0, 0.12)",
                  }}
                />
              </LazyLoad>
            </div>
          </div>
        </div>
      </div>

      {/* Recent Updates Section */}
      <section id="updates">
        <div style={{ padding: "80px 0" }}>
          <div className="container">
            <div style={{ maxWidth: "800px", margin: "0 auto" }}>
              <h2
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "600",
                  color: "#1a1a2e",
                  marginBottom: "40px",
                }}
              >
                Recent Updates
              </h2>

              {/* Registration Card */}
              <div
                style={{
                  background: "#fff",
                  borderRadius: "16px",
                  padding: "32px",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.06)",
                  border: "1px solid #e8eef3",
                  marginBottom: "40px",
                }}
              >
                <h3
                  style={{
                    fontSize: "1.3rem",
                    fontWeight: "600",
                    color: "#1a1a2e",
                    marginBottom: "12px",
                  }}
                >
                  2026 Results
                </h3>
                <p
                  style={{
                    fontSize: "1rem",
                    color: "#555",
                    lineHeight: "1.7",
                    margin: 0,
                  }}
                >
                  The 2026 International Research Olympiad has concluded and the
                  winners have been announced! View the results in the{" "}
                  <a
                    href="/winners-hub"
                    style={{ color: "#004d99", fontWeight: "600" }}
                  >
                    Winners Hub
                  </a>{" "}
                  and claim your certificate.
                </p>
              </div>


              {/* Updates Timeline */}
              <div style={{ marginTop: "40px" }}>
                <h3
                  style={{
                    fontSize: "1.3rem",
                    fontWeight: "600",
                    color: "#1a1a2e",
                    marginBottom: "24px",
                  }}
                >
                  News & Announcements
                </h3>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                  }}
                >
                  {[
                    {
                      date: "6/21/26",
                      text: "Winners of the 2026 IRO were announced at Harvard Square, Cambridge, MA!",
                    },
                    {
                      date: "6/8/25",
                      text: "Winners of the IRO 2025 were announced in Cambridge, MA!",
                    },
                    {
                      date: "2/3/25",
                      text: "Registration for the 2025 IRO has opened!",
                    },
                    {
                      date: "6/6/24",
                      text: "Winners of the IRO 2024 were announced in Cambridge, MA!",
                    },
                    {
                      date: "5/5/24",
                      text: "Results for the 2024 IRO Semifinals Exam Released!",
                    },
                    {
                      date: "3/28/24",
                      text: "Results for the 2024 IRO Opens Exam Released!",
                    },
                    {
                      date: "2/28/24",
                      text: "IRO Finals will be held at Harvard Square!",
                    },
                    {
                      date: "2/3/24",
                      text: "Registration for the 2024 IRO has opened!",
                    },
                    {
                      date: "2/1/24",
                      text: "Our 2024 Board of Advisors has been finalized!",
                    },
                    {
                      date: "1/25/24",
                      text: "Our 2024 Student Board of Advisors has been publicly released!",
                    },
                    {
                      date: "1/1/24",
                      text: "Our 2024 online community has been publicly released!",
                    },
                  ].map((item, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        gap: "16px",
                        padding: "16px 20px",
                        backgroundColor:
                          index === 0 ? "rgba(0, 77, 153, 0.05)" : "#fff",
                        borderRadius: "10px",
                        border: "1px solid #e8eef3",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "0.85rem",
                          fontWeight: "600",
                          color: "#004d99",
                          minWidth: "70px",
                        }}
                      >
                        {item.date}
                      </span>
                      <span style={{ fontSize: "0.95rem", color: "#555" }}>
                        {item.text}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default News;
